<template>
  <div class="deliverable-projects" v-if="deliverable">
    <template v-if="!disabled">
      <div class="pb-0 titles exclude-outside-click" v-if="!addProjectFlag">
        <div
          class="department-title exclude-outside-click"
          :class="canEditDeliverableProject(deliverable.project_id) ? '' : 'pointer-default'"
          :key="'deliverable-modal-department-'+deliverable.project_id.id"
          v-if="deliverable.project_id"
          @click="goToProject(deliverable.project_id.id)"
        >
        {{ deliverable.project_id.name }}
        <span
          v-if="deliverable.project_id.project_status && deliverable.project_id.project_status.slug && deliverable.project_id.project_status.slug=='on-hold'">
          : 
          {{ deliverable.project_id.project_status.name }}
        </span>
        </div>
        <div @click="showAddProject()" class="department-title exclude-outside-click" v-if="!deliverable.project_id  && getDeliverableTemplateSlug(deliverable.deliverable_template_id) != 'social-media'">No Project</div>
        <button @click="showAddProject()" v-if="canEditDeliverableProject(deliverable.project_id)  && getDeliverableTemplateSlug(deliverable.deliverable_template_id) != 'social-media'" type="button" class="plus-button plus-button--small exclude-outside-click">
          <img class="exclude-outside-click" src="@/csmworkflow/img/pencil.svg" />
        </button>
      </div>


      <multiselect
        ref="deliverableProjects"
        v-click-outside="outside"
        v-if="addProjectFlag"
        v-model="deliverable.project_id"
        :close-on-select="true"
        :options="projectsOption"
        :show-labels="false"
        :multiple="false"
        :taggable="false"
        label="name"
        track-by="id"
        group-label="group"
        group-values="entries"
        :group-select="false"
        :id="deliverable.deliverableId"
        @input="onProjectSelected(deliverable)"
        @close="addProjectFlag = false"
      ></multiselect>


    </template>
    <template v-else>
      <div class="pb-0 titles exclude-outside-click">
      	<div
      	  class="department-title exclude-outside-click"
      	  :class="canEditDeliverableProject(deliverable.project_id) ? '' : 'pointer-default'"
      	  :key="'deliverable-modal-department-'+deliverable.project_id.id"
      	  v-if="deliverable.project_id"
      	  @click="goToProject(deliverable.project_id.id)"
      	>
      	  {{ deliverable.project_id.name }}
          <span
            v-if="deliverable.project_id.project_status && deliverable.project_id.project_status.slug && deliverable.project_id.project_status.slug=='on-hold'">
            ({{ deliverable.project_id.project_status.name }})
          </span>
      	</div>
        <div class="department-title exclude-outside-click" v-if="!deliverable.project_id">No Project</div>
      </div>
    </template>
  </div>
</template>

<script>

const RECENT_PROJECTS_KEY = 'recentProjects';
const MAX_RECENT = 10;


import { mapActions, mapState, mapMutations } from "vuex";
import toast from "../../toast";

export default {
  props: ["deliverable","disabled", "namespace"],
  data() {
    return {
      addProjectFlag: false
    };
  },
  computed: {
  	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  allProjects (state, getters) {
  	    return getters['allProjects']
  	  },
  	  recentProjectIds (state, getters) {
  	  	return getters['recentProjectIds']
  	  },
  	  userAbilities (state, getters) {
  	    return getters['userAbilities']
  	  },
  	  userManageProjects (state, getters) {
  	    return getters['userManageProjects']
  	  },
  	  getDeliverableTemplateSlug (state, getters) {
  	    return getters['getDeliverableTemplateSlug']
  	  },
  	}),
  	projectsOption() {
  		const selectedId = this.deliverable.project_id?.id ?? null;

  	   // ── Branch: user can manage only their own projects ──────────
  	   if (!this.userAbilities.accessAllProjects) {
  	     if (!this.userManageProjects) return [];


  	     const mapped = this.userManageProjects.map(elem => ({
  	       id: elem.id,
  	       name: elem.title,
  	       engagement_manager: elem.engagement_manager,
  	       project_lead: elem.project_lead,
  	     }));


  	   }


  	   // ── Branch: user has access to all projects ──────────────────
  	   if (!this.allProjects) return [];

  	   // Map all projects into a flat shape
  	   // const mapped = this.allProjects.map(elem => ({
  	   //   id: elem.id,
  	   //   name: elem.title,
  	   //   engagement_manager: elem.engagement_manager,
  	   //   project_lead: elem.project_lead,
  	   // }));


  	   const mapped = this.allProjects.map(elem => {
  	      const dueDate = elem.due_date ? this.$moment(elem.due_date).format('MMM YYYY') : 'No Date';
  	     return {
  	       id: elem.id,
  	       name: `${elem.title} (${elem.project_number}) - Due: ${dueDate}`,
  	       engagement_manager: elem.engagement_manager,
  	       project_lead: elem.project_lead,
  	     };
  	   });




  	   // ── Selected group ────────────────────────────────────────────
  	   const selectedEntries = selectedId
  	     ? mapped.filter(p => p.id === selectedId)
  	     : [];

  	   // ── Recent group: everyone except the selected project ────────
  	   const rest = mapped.filter(p => p.id !== selectedId);

  	   // Split into "has a recent rank" vs "never visited"
  	   const recentIndexOf = p => this.recentProjectIds.indexOf(p.id);
  	   const inRecent    = rest.filter(p => recentIndexOf(p) !== -1);
  	   const notInRecent = rest.filter(p => recentIndexOf(p) === -1);

  	   // Sort by recency position, then alphabetically for the tail
  	   inRecent.sort((a, b) => recentIndexOf(a) - recentIndexOf(b));
  	   notInRecent.sort((a, b) => a.name.localeCompare(b.name));

  	   const recentEntries = [...inRecent, ...notInRecent];

  	   return [
  	     { group: 'Selected', entries: selectedEntries },
  	     { group: 'Recent',   entries: recentEntries   },
  	   ];
  	 },


    OLD_projectsOption() {
      if (this.userAbilities.accessAllProjects) {
        if(this.allProjects) {
          let allProjectArr = [];
          let obj =
          allProjectArr.push({group:"Selected", entries:[]});
          allProjectArr.push({group:"Recent", entries:[]});
          let x = 0;
          this.allProjects.forEach(elem => {
	          	x = parseInt(Math.random() * 4);
	          	if (x > 1) x = 1;
	          	if (x < 1) {
		          	if (allProjectArr[x].entries.length > 1) x = 1;
		          }
		          if (x == 0) {
								 x = 1;
		          }
		          if (this.deliverable.project_id) {
			          if (elem.id == this.deliverable.project_id.id) {
			          	x = 0;
			          }
			        }
	          	allProjectArr[x].entries.push({id: elem.id, name: elem.title, engagement_manager: elem.engagement_manager, project_lead: elem.project_lead});
          });
          return allProjectArr;
        }
      } else {
        if(this.userManageProjects) {
          let projectArr = [];
          this.userManageProjects.forEach(elem => {
            projectArr.push({id: elem.id, name: elem.title, engagement_manager: elem.engagement_manager, project_lead: elem.project_lead});
          });
          return projectArr;
        }
      }
    },
    hasProjectOption() {
      return this.projectsOption && this.projectsOption.length > 0;
    },
  },
  methods: {
  	...mapActions({
  	  setDeliverableProject (dispatch, payload) {
  	    return dispatch(this.namespace + 'setDeliverableProject', payload)
  	  },

  	  getRecentProjectIds() {
  	    try {
  	      return JSON.parse(localStorage.getItem(RECENT_PROJECTS_KEY)) || [];
  	    } catch {
  	      return [];
  	    }
  	  },
  	  updateRecentProjects(projectId) {
  	    if (!projectId) return;
  	    const recent = this.getRecentProjectIds().filter(id => id !== projectId);
  	    recent.unshift(projectId);                        // most recent first
  	    localStorage.setItem(
  	      RECENT_PROJECTS_KEY,
  	      JSON.stringify(recent.slice(0, MAX_RECENT))
  	    );
  	  },


  	  fetchProjects (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchProjects', payload)
  	  },
  	  fetchUserManageProjects (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchUserManageProjects', payload)
  	  },
  	  fetchProjectDeliverableById (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchProjectDeliverableById', payload)
  	  },
  	  getProjectNumberFromId (dispatch, payload) {
  	    return dispatch(this.namespace + 'getProjectNumberFromId', payload)
  	  },
  	  fetchAllProjects (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchAllProjects', payload)
  	  },
  	}),
  	...mapMutations({
  	  setDataLoading (commit, payload) {
  	    return commit(this.namespace + 'setDataLoading', payload)
  	  },
  	}),

  	onProjectSelected(deliverable) {
  	  if (deliverable.project_id?.id) {
  	    this.$store.dispatch('addRecentProject', deliverable.project_id.id);
  	  }
  	  this.setDeliverableProject(deliverable);
  	},


    showAddProject() {
     if (this.userAbilities.accessAllProjects) {
      this.fetchAllProjects()
     }

      if(!this.canEditDeliverableProject(this.deliverable.project_id)) return;
      if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.addProjectFlag = true
      this.$nextTick(() => {
        this.$refs.deliverableProjects.$el.focus()
      })
    },
    outside() {
      this.$set(this, "addProjectFlag", false);
    },
    userCanEditProject(project) {
      if (!project) return false;

      const userId = localStorage.getItem("userId");

			if (this.userAbilities.accessAllProjects) {
				return this.userAbilities.editProject;
			}

			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}

			return (this.userAbilities.editProject && isManager);
    },
    canEditDeliverableProject(project) {
      if (this.userAbilities.accessAllProjects) return true;
      if (!this.hasProjectOption) return false;

      const userId = localStorage.getItem("userId");
      let isManager = false;
      if (project) {
        if (project.engagement_manager instanceof Object && project.project_lead instanceof Object) {
          isManager = userId == project.engagement_manager.id || userId == project.project_lead.id;
        } else {
          isManager = userId == project.engagement_manager || userId == project.project_lead;
        }
      } else {
        isManager = true;
      }

      return (this.userAbilities.editMediaCall && isManager);
    },

    goToProject(projectId) {
      this.setDataLoading(true);
      this.getProjectNumberFromId(projectId).then((projectNumber) => {
        this.fetchProjectDeliverableById(projectNumber).then(() => {
          this.setDataLoading(false);
          const isNumber = !isNaN(Number(projectNumber));
          if (isNumber) {
            this.$router.push(`/project/${projectNumber}`);
          } else {
            toast.error('Invalid project.');
          }
        });
      })
		},
  },
};
</script>

<style lang="scss">
.parent-project-on-hold .deliverable-projects .department-title {
  font-weight: 600 !important;
}
</style>
